import { useContext } from 'react';
import { OnlineStatusContext } from '../context/OnlineStatusContext';

export const useOnlineStatus = () => {
    const context = useContext(OnlineStatusContext);
    if (!context) {
        throw new Error('useOnlineStatus must be used within a OnlineStatusProvider');
    }
    return context;
};
